import styled from 'styled-components';
export const Container = styled.div`
  position: absolute;
  display: flex;
  height: 100%; 
  width: 100%; 
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #ffffffff;
`
export const Content = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 2rem;

    .line--{
        display: flex;
        flex-direction: row;
        gap: 3rem;
    }
    .area-icon{
        display: flex;
        font-size: 6rem;
        color: #1D86FF;
    }
    .laptop{
        padding-left: 1rem;
        padding-right: 1rem;
    }
    .loader{
        width: 12px;
        height: 12px;
        border-radius: 50%;
        color: #1D86FF;
        box-sizing: border-box;
        animation: animloader 1.5s linear infinite;
    }
    @keyframes animloader {
        0% {
            box-shadow: 14px 0 0 -2px,  38px 0 0 -2px,  -14px 0 0 -2px,  -38px 0 0 -2px;
        }
        25% {
            box-shadow: 14px 0 0 -2px,  38px 0 0 -2px,  -14px 0 0 -2px,  -38px 0 0 2px;
        }
        50% {
            box-shadow: 14px 0 0 -2px,  38px 0 0 -2px,  -14px 0 0 2px,  -38px 0 0 -2px;
        }
        75% {
            box-shadow: 14px 0 0 2px,  38px 0 0 -2px,  -14px 0 0 -2px,  -38px 0 0 -2px;
        }
        100% {
            box-shadow: 14px 0 0 -2px,  38px 0 0 2px,  -14px 0 0 -2px,  -38px 0 0 -2px;
        }
    }
    .progress--bar{
       display: flex;
       width: calc(100% + 6rem);
       height: 3px;
       border-radius: 2px;
       background-color: #1D86FF;
    }
    p{
        font-size: 1.2rem;
        font-weight: 100;
        color:#1D86FF;
    }
`   